import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { useToast } from '../contexts/ToastContext';

export function ResetPasswordPage() {
  const { token } = useParams<{ token: string }>();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) {
      toast.error('Token saknas');
      return;
    }
    if (password.length < 8) {
      toast.error('Lösenord måste vara minst 8 tecken');
      return;
    }
    if (password !== confirmPassword) {
      toast.error('Lösenorden matchar inte');
      return;
    }
    setLoading(true);
    try {
      await api.post<{ ok: boolean }>('/auth/reset-password', { token, password });
      toast.success('Lösenord uppdaterat');
      navigate('/login', { replace: true });
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Kunde inte återställa lösenord');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <div className="w-full max-w-sm">
        <div className="h-10 flex items-center justify-center mb-6">
          <img src="/logga.png" alt="ApisAI" className="h-10 w-auto max-w-full" />
        </div>
        <h1 className="text-lg font-semibold mb-3">Nytt lösenord</h1>
        <form onSubmit={onSubmit} className="space-y-3">
          <input
            type="password"
            placeholder="Nytt lösenord"
            className="w-full"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
          />
          <input
            type="password"
            placeholder="Bekräfta nytt lösenord"
            className="w-full"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full py-1.5 px-3 bg-primary text-white rounded hover:bg-primary-hover disabled:opacity-50"
          >
            {loading ? 'Sparar...' : 'Spara nytt lösenord'}
          </button>
        </form>
        <p className="text-sm text-gray-600 mt-3">
          <Link to="/login" className="text-primary hover:underline">
            Tillbaka till login
          </Link>
        </p>
      </div>
    </div>
  );
}

